import React from "react";
import Todo from "./components/Todo.js";

const App = () =>{

    return(
        <Todo/>
    );
}

export default App;